<template lang="pug">
.issueList
  //- 批注列表
  notationList(ref="notationList")
</template>

<script>
import { mapState } from "vuex";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
import notationList from "@/CommonDP/mongeView/appView/question/notationList.vue";

export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    }
  },
  components: { notationList },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    filData() {
      return JSON.parse(mongeApp.other.fileInfo);
    }
  },
  mounted() {
    this.openNotationList();
  },
  methods: {
    // 打开批注列表
    openNotationList() {
      const { fileId, prjId } = this.filData;
      const params = { prjId, fileId };
      this.$refs.notationList.open(params);
    }
  }
};
</script>

<style lang="scss" scoped></style>
